var SearchStatus = /* @__PURE__ */ ((SearchStatus2) => {
  SearchStatus2["New"] = "new";
  SearchStatus2["Running"] = "running";
  SearchStatus2["Completed"] = "completed";
  SearchStatus2["Stopped"] = "stopped";
  return SearchStatus2;
})(SearchStatus || {});
var DateRange = /* @__PURE__ */ ((DateRange2) => {
  DateRange2["LastOneWeek"] = "last one week";
  DateRange2["LastOneMonth"] = "last one month";
  DateRange2["YearToDate"] = "year to date";
  DateRange2["AllTime"] = "all";
  return DateRange2;
})(DateRange || {});
const featureSearchContextQueryParams = Object.keys({
  filterText: "",
  workspaceId: "",
  keywordSearch: "",
  subscriber: "",
  experimentationGroup: [],
  isolationGroups: [],
  statuses: [],
  startedAfter: /* @__PURE__ */ new Date(),
  startedBefore: /* @__PURE__ */ new Date(),
  isArchived: false,
  page: 1,
  pageSize: 1,
  collapseRolloutTargetsIntoRoot: false,
  onlyLoadFeatureData: false,
  dateRange: "all".toString()
});
export {
  DateRange,
  SearchStatus,
  featureSearchContextQueryParams
};
//# sourceMappingURL=IFeatureSearchContext.js.map
